import React from 'react';

const OffNadirIcon = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      {...props}
    >
      <path 
        d="M9 6.75C9 6.55109 9.07902 6.36032 9.21967 6.21967C9.36032 6.07902 9.55109 6 9.75 6C12.335 6.00273 14.8134 7.03084 16.6413 8.85872C18.4692 10.6866 19.4973 13.165 19.5 15.75C19.5 15.9489 19.421 16.1397 19.2803 16.2803C19.1397 16.421 18.9489 16.5 18.75 16.5C18.5511 16.5 18.3603 16.421 18.2197 16.2803C18.079 16.1397 18 15.9489 18 15.75C17.9975 13.5627 17.1275 11.4657 15.5809 9.91911C14.0343 8.37247 11.9373 7.50248 9.75 7.5C9.55109 7.5 9.36032 7.42098 9.21967 7.28033C9.07902 7.13968 9 6.94891 9 6.75ZM22.5 18H7.5V3C7.5 2.80109 7.42098 2.61032 7.28033 2.46967C7.13968 2.32902 6.94891 2.25 6.75 2.25C6.55109 2.25 6.36032 2.32902 6.21967 2.46967C6.07902 2.61032 6 2.80109 6 3V6H3C2.80109 6 2.61032 6.07902 2.46967 6.21967C2.32902 6.36032 2.25 6.55109 2.25 6.75C2.25 6.94891 2.32902 7.13968 2.46967 7.28033C2.61032 7.42098 2.80109 7.5 3 7.5H6V18.75C6 18.9489 6.07902 19.1397 6.21967 19.2803C6.36032 19.421 6.55109 19.5 6.75 19.5H22.5C22.6989 19.5 22.8897 19.421 23.0303 19.2803C23.171 19.1397 23.25 18.9489 23.25 18.75C23.25 18.5511 23.171 18.3603 23.0303 18.2197C22.8897 18.079 22.6989 18 22.5 18Z" 
        fill={color}
      />
    </svg>
  );
};

export default OffNadirIcon;

